const paginationLocalization = {
  label: 'Pagination',
}

export default paginationLocalization
